module.exports = __webpack_public_path__ + "img/articletop_sm.ac396e89.png";